export var ARTICLE_BOX_SKELETON = 'article-box-skeleton';
//# sourceMappingURL=constants.js.map